import { forwardRef, HTMLAttributes } from "react";
import SizeType from "../types/size";
import WeightType from "../types/weight";
import transFontSize from "./utils/transFontSize";
import clsx from "clsx";
import transFontWeight from "./utils/transFontWeight";
import TextType from "../types/text";

type TextSizeType = Omit<SizeType, "default">;
type TextWeightType = Omit<WeightType, "default">;

type TextProps = HTMLAttributes<HTMLElement> & {
    variant?: TextType,
    size?: TextSizeType | number | string,
    weight?: TextWeightType,
    color?: string,
    noWrap?: boolean,
    textAlign?: "left" | "center" | "right" | "justify",
};

const Text = forwardRef<HTMLElement, TextProps>(({children, variant = "p", size = "md", weight = "sm" as TextWeightType, color, noWrap = true, textAlign = "left", style, className, ...props}, ref) => {
    const Component = variant as React.ElementType;
    const fontSizeValue = transFontSize({size});
    const fontWeightValue = transFontWeight({weight});
    const whiteSpaceValue = noWrap ? "nowrap" : "normal";
    return (
        <Component 
            ref={ref}
            style={{fontSize: fontSizeValue, fontWeight: fontWeightValue, color: color, whiteSpace: whiteSpaceValue, textAlign: textAlign, ...style}} 
            className={clsx("text", className)} 
            {...props}
        >
            {children}
        </Component>
    );
});

Text.displayName = "Text";

export default Text;

export type { TextProps, TextSizeType, TextWeightType };